module.exports = __webpack_public_path__ + "static/media/cs_logo.519d7602.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs_logo.png
// module id = 677
// module chunks = 0